module.exports = __webpack_public_path__ + "static/media/rs1.a08e8a27.png";